// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"d86a57bc","491":"b7a0f1e8","505":"dd435341","992":"c0ca74cd"}[chunkId] + ".chunk.css";
};